<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-3">
      <PageTitle title="Contatos e redes sociais" />
    </b-col>
    <b-col cols="12" class="mb-5">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=PXZhDrCaHWc&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=6', 
            title: 'Contatos e redes sociais' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a
          class="btn btn-success"
          href="https://api.construp.com.br/assets/Contatos e Rede Sociais.pdf"
          target="_blank"
          download
          ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
        >
      </b-col>
    <b-col cols="12" lg="5">
      <b-row
        v-for="(socialMedia, index) in socialMedias"
        :key="index"
        class="mb-4"
      >
        <b-col cols="12" class="mb-1">
          <i :class="socialMedia.logo"></i>
          <span class="ml-2">{{ socialMedia.name }}</span>
          <b-form-checkbox
            v-if="socialMedia.type == '3'"
            v-model="fields[socialMedia.key].enable_whatsapp"
            switch
            class="d-inline ml-4"
          >
            Ícone whatsapp
          </b-form-checkbox>

          <b-form-checkbox
            v-if="socialMedia.type == '3'"
            v-model="fields[socialMedia.key].purchase_whatsapp"
            switch
            class="d-inline ml-4"
          >
            Vender por WhatsApp?
          </b-form-checkbox>
        </b-col>

        <b-col cols="12">
          <input
            v-if="fields[socialMedia.key].type === SOCIAL_MEDIAS.TELEPHONE || fields[socialMedia.key].type === SOCIAL_MEDIAS.WHATSAPP"
            type="text"
            v-model="fields[socialMedia.key].link"
            v-mask="['(##) #####-####', '(##) ####-####']"
            class="form-control"
          />
          <input
            v-else
            type="text"
            v-model="fields[socialMedia.key].link"
            class="form-control"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="mb-2" v-if="whatClerkPermission()">
          <b-button block variant="success" @click="save()">
            <i class="fas fa-save mr-2"></i>
            Salvar
          </b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col class="ml-3 mb-5">
      <FakeAppTemplate
        v-slot="{
          categories,
          iconStyle,
          fontStyle,
          backgroundStyle,
          headerStyle,
          companyInfo,
        }"
        :enable_whatsapp="fields.whatsapp.enable_whatsapp"
      >
        <b-row class="text-center">
          <b-col cols="12" class="my-2">
            <span class="fs-20" :style="fontStyle">
              {{ companyInfo.title }}
            </span>
          </b-col>
          <b-col cols="12" class="my-2">
            <span :style="fontStyle" v-html="companyInfo.resume" />
          </b-col>
          <b-col cols="12" class="my-2">
            <img 
              v-if="companyInfo.image"
              :src="`${getImagesAddressApp}${companyInfo.image}`" 
              class="imgWidget"
            />
            <div v-else></div>
          </b-col>
          <b-col cols="12" class="my-2">
            <span :style="fontStyle" v-html="companyInfo.subject" />
          </b-col>
          <b-col
            cols="12"
            class="my-2"
            :key="companyInfo.video"
            v-if="companyInfo.video"
          >
            <iframe
              width="100%"
              height="100%"
              :src="`https://www.youtube.com/embed/${getYoutubeVideoUri(
                companyInfo.video
              )}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </b-col>
          <b-col v-if="validSocialMedias.length > 0" cols="12" class="my-1 text-center">
            <span class="fs-20" :style="fontStyle">
              Nos encontre nas redes sociais
            </span>
          </b-col>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center"
          >
          <span
            v-for="(socialMedia, index) in validSocialMedias"
          >
            <a
              v-if="socialMedia.type === SOCIAL_MEDIAS.WHATSAPP"
              :href="`https://wa.me/+55${formatNumber(socialMedia.link)}`"
              target="_blank"
              class="ml-3 c-pointer"
            >
              <i
                :class="`${getSocialMediaIcon(socialMedia.type)}`"
                :style="`${iconStyle}`"
                class="fs-24"
              ></i>
            </a>

            <a
              v-else
              :href="
                isTelephone(socialMedia.type)
                  ? `tel:+55${socialMedia.link}`
                  : socialMedia.link
              "
              target="_blank"
              :key="index"
              class="ml-3 c-pointer"
            >
              <i
                :class="`${getSocialMediaIcon(socialMedia.type)}`"
                :style="`${iconStyle}`"
                class="fs-24"
              ></i>
            </a>
          </span>
          </b-col>
        </b-row>
      </FakeAppTemplate>
    </b-col>
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import SOCIAL_MEDIAS from 'Enums/SocialMedias.js';
import makeToast from '../../../mixins/makeToast';
import { getYoutubeVideoUri } from 'Utils/index.js';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

import PageTitle from '../../../components/PageTitle.vue';
import FakeAppTemplate from './FakeAppTemplate.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'CustomizationSocialMedias',
  components: { PageTitle, FakeAppTemplate, VideoManual },
  mixins: [makeToast],
  data() {
    return {
      iconPermission: false,
      SOCIAL_MEDIAS,
      loading: false,
      companyInfo: {},
      fields: {
        instagram: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.INSTAGRAM,
        },
        facebook: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.FACEBOOK,
        },
        whatsapp: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.WHATSAPP,
          enable_whatsapp: false,
          purchase_whatsapp: false,
        },
        telephone: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.TELEPHONE,
        },
        twitter: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.TWITTER,
        },
        youtube: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.YOUTUBE,
        },
        tiktok: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.TIKTOK,
        },
        email: {
          id: 0,
          link: '',
          type: SOCIAL_MEDIAS.EMAIL,
        },
      },
      socialMedias: [
        {
          key: 'instagram',
          logo: 'fab fa-instagram',
          name: 'Link Instagram',
          type: SOCIAL_MEDIAS.INSTAGRAM,
        },
        {
          key: 'facebook',
          logo: 'fab fa-facebook',
          name: 'Link Facebook',
          type: SOCIAL_MEDIAS.FACEBOOK,
        },
        {
          key: 'whatsapp',
          logo: 'fab fa-whatsapp',
          name: 'Número do Whatsapp',
          type: SOCIAL_MEDIAS.WHATSAPP,
        },
        {
          key: 'telephone',
          logo: 'fas fa-phone',
          name: 'Telefone fixo',
          type: SOCIAL_MEDIAS.TELEPHONE,
        },
        {
          key: 'twitter',
          logo: 'fab fa-twitter',
          name: 'Link Twitter',
          type: SOCIAL_MEDIAS.TWITTER,
        },
        {
          key: 'youtube',
          logo: 'fab fa-youtube',
          name: 'Link Youtube',
          type: SOCIAL_MEDIAS.YOUTUBE,
        },
        {
          key: 'tiktok',
          logo: 'fab fa-tiktok',
          name: 'Link TikTok',
          type: SOCIAL_MEDIAS.TIKTOK,
        },
        {
          key: 'email',
          logo: 'fas fa-envelope',
          name: 'Email',
          type: SOCIAL_MEDIAS.EMAIL,
        },
      ],
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
    validSocialMedias() {
      const socialMedias = [];

      Object.keys(this.fields).forEach((key) => {
        if (!this.fields[key].link) return;

        socialMedias.push(this.fields[key]);
      });
      return socialMedias;
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    activeWhatsapp() {
      
    },

    getYoutubeVideoUri,
    ...mapActions('shopkeeper', ['saveSocialMedias', 'getSocialMedias']),
    get() {
      this.loading = true;
      this.$store.dispatch('startLoader');

      const userId = this.dadosUsuario.tipo_usuario_id === UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;

      this.getSocialMedias(userId)
        .then((response) => {
          if (!response.data.data || !response.data.data.length) return;

          response.data.data.forEach((socialMedia) => {
            Object.keys(this.fields).forEach((key) => {
              if (this.fields[key].type !== socialMedia.type) return;

              this.fields[key] = {
                id: socialMedia.id,
                link: socialMedia.link,
                type: socialMedia.type,
                enable_whatsapp: socialMedia.enable_whatsapp == 1 ?
                  socialMedia.enable_whatsapp = true : socialMedia.enable_whatsapp = false,
                purchase_whatsapp: socialMedia.purchase_whatsapp == 1 ?
                  socialMedia.purchase_whatsapp = true : socialMedia.purchase_whatsapp = false,
              };
            });
          });
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as redes sociais',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    save() {
      const userId = this.dadosUsuario.tipo_usuario_id === UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
      const request = {
        userId: userId,
        socialMedias: [],
      };

      Object.keys(this.fields).forEach((key) => {
        request.socialMedias.push({
          name: key,
          id: this.fields[key].id,
          type: this.fields[key].type,
          link: this.fields[key].link,
          enable_whatsapp: this.fields[key].enable_whatsapp,
          purchase_whatsapp: this.fields[key].purchase_whatsapp,
        });
      });
      
      this.$store.dispatch('startLoader');

      this.saveSocialMedias(request)
        .then(() => {
          this.makeToast('Sucesso', 'Contato e redes sociais salvas com sucesso');
          this.$root.$emit('valid-available-app');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    isTelephone(type) {
      return type === SOCIAL_MEDIAS.TELEPHONE;
    },
    getSocialMediaIcon(type) {
      return this.socialMedias.find((x) => x.type === type).logo;
    },
    formatNumber(number) {
      let numberFormat = number.replace(/[^0-9]+/g,'');
      return numberFormat;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.CUSTOMIZACAO_SOCIAL);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    }
  },
};
</script>

<style scoped>
.imgWidget {
  width: 300px;
}
</style>